module.exports = __webpack_public_path__ + "static/video-f487d02ba79888f79b188782174d3236.png";